const ErmsUrl = "https://jzpxb.yunvip123.com";
// const ErmsUrl = "https://pxbjz.getdreamstar.com";

export default {
  ErmsUrl
};



// WEBPACK FOOTER //
// ./src/api/etmsConfig.js